import { API, API_POST } from "../../Config";

export const handleAddProduct = (payload) => {
  const f = new FormData();
  Array.from(payload.image).forEach((img, idx) => {
    f.append(`p_images[${idx}]`, img);
  });

  f.append("product_name", payload.product_name);
  f.append("actual_price", payload.actual_price);
  f.append("discount_price", payload.discount_price);
  f.append("available_stock", payload.available_stock);
  f.append("description", payload.description);
  f.append("cat_id", payload.product_category);

  return API_POST(API.AddProductUrl, f);
};
